export default {
    topbar: { delivery: "จัดส่งในพื้นที่รวดเร็ว • HE / EN / TH", support: "ช่วยเหลือ", orders: "คำสั่งซื้อ", about: "เกี่ยวกับเรา" },
    header: {
        searchPlaceholder: "ค้นหาสินค้า แบรนด์ และหมวดหมู่…", language: "ภาษา", notifications: "การแจ้งเตือน",
        hello: "สวัสดี", account: "บัญชี", signIn: "เข้าสู่ระบบ", signUp: "สมัครสมาชิก", shoppingCart: "รถเข็น", myOrders: "คำสั่งซื้อของฉัน", settings: "การตั้งค่า", signOut: "ออกจากระบบ", theme: "ธีม", dark: "มืด", light: "สว่าง", darkTheme: "ธีมมืด", lightTheme: "ธีมสว่าง", cartItems: "{{count}} รายการ"
    },
    filters: {
        discover: "ค้นพบ", realProducts: "สินค้าจาก Pitango", newArrivals: "สินค้าใหม่", reorder: "พร้อมสั่งซ้ำ",
        thaiProducts: "สินค้าไทย", drinks: "เครื่องดื่ม", snacks: "ขนม", offers: "ข้อเสนอพิเศษ"
    },
    mobileNav: { home: "หน้าแรก", categories: "หมวดหมู่", search: "ค้นหา", menu: "เมนู", cart: "ตะกร้า" },
    sidebar: {
        title: "หมวดหมู่สินค้า", subtitle: "ทุกอย่างเข้าถึงได้ง่าย", discover: "ค้นพบ", homePage: "หน้าแรก", beverages: "เครื่องดื่ม",
        instantFood: "อาหารสำเร็จรูป", riceNoodles: "ข้าวและเส้น", snacks: "ขนม", household: "ของใช้ในบ้าน",
        personalCare: "ของใช้ส่วนตัว", deals: "โปรโมชั่น", promoTitle: "สั่งซื้อซ้ำได้รวดเร็ว",
        promoText: "นำสินค้าที่ซื้อเป็นประจำกลับมาได้เร็วขึ้น ลดขั้นตอนสำหรับลูกค้าที่กลับมาซื้ออีกครั้ง",
        subcategories: {
            coffeeTea: "กาแฟและชา", milkPowder: "นมผง", softDrinks: "น้ำอัดลมและเครื่องดื่ม",
            noodles: "เส้นและบะหมี่", soups: "ซุป", readyMeals: "อาหารพร้อมทาน", rice: "ข้าว", saucesSeasoning: "ซอสและเครื่องปรุง",
            cookies: "คุกกี้", chips: "มันฝรั่งทอด", sweets: "ขนมหวาน", cleaning: "ทำความสะอาด", laundry: "ซักผ้า", paperGoods: "ผลิตภัณฑ์กระดาษ",
            soapShampoo: "สบู่และแชมพู", dentalCare: "ดูแลช่องปาก", dailyEssentials: "ของใช้ประจำวัน"
        }
    }
} as const;
